import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);
export default new Vuex.Store({
    state: {
        num: sessionStorage.getItem('num'),
        rightTitle: sessionStorage.getItem('rightTitle'),
        language: sessionStorage.getItem('language')?sessionStorage.getItem('language'):'cn',
        statistics:sessionStorage.getItem("statistics")
    },
    mutations: {
        //改变数字
        changeNum(state, val) {
            state.num = val
            window.sessionStorage.setItem('num', val)
        },
        // 改变顶部右侧的文字
        changeTitle(state, val) {
            state.rightTitle = val
            window.sessionStorage.setItem('rightTitle', val)
        },
        changeLanguage(state, val) {
            state.language = val
            window.sessionStorage.setItem('language', val)
        },
        changeStatistics(state, val) {
            state.statistics = val
            window.sessionStorage.setItem('statistics', val)
        },
    },
    actions: {},
    modules: {},
});